import { inputFunc } from "../../lib/inputFunctions";
import "./textarea.css";

type TextInputProps = {
  state: { [key: string]: any };
  setState: React.Dispatch<React.SetStateAction<{ [key: string]: any }>>;
  stateKey: string;
  label?: string;
  placeholder?: string;
  errorMessage?: string;
  pattern?: { [key: string]: any };
  required?: boolean;
  readonly?: boolean;
  format?: "toNumber" | "toPhoneNumber" | "toMoney";
};

export function Textarea({
  state,
  stateKey,
  setState,
  label,
  placeholder,
  pattern,
  required,
  readonly,
  format,
}: TextInputProps) {
  const valid = new RegExp(pattern ? pattern.pattern : "").test(state[stateKey]?.toString() ?? "");

  return (
    <div className="textarea-container">
      {label && (
        <div className="textarea-label">
          <label>{label}</label>
        </div>
      )}
      <div className="textarea-wrapper">
        <div className="textareafield-wrapper">
          <textarea
            value={state[stateKey]}
            rows={4}
            id={stateKey}
            name={stateKey}
            className={`textareafield`}
            onChange={(e) => inputFunc.changeObj(e.target.value, setState, stateKey, format)}
            placeholder={placeholder}
            required={required}
            readOnly={readonly}
          />
        </div>
      </div>
      {pattern && state[stateKey] && !valid && <div className="input-error">{pattern.message}</div>}
    </div>
  );
}
